import { availability, healthEducation, medicalAdvices, onlineConsultation } from "../assets";

export const features = [
    {
        icon: onlineConsultation,
        description: "Online consultations"
    },
    {
        icon: medicalAdvices,
        description: "Medical advice and second opinions"
    },
    {
        icon: availability,
        description: "availability 24/7"
    },
    {
        icon: healthEducation,
        description: "Health education and resources"
    }
];